var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 64,
    viewBox: "0 0 75 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1123 47.1185V14.7185C6.1123 14.1218 6.34936 13.5495 6.77131 13.1275C7.19327 12.7056 7.76557 12.4685 8.3623 12.4685H55.6353C56.232 12.4685 56.8043 12.7056 57.2263 13.1275C57.6483 13.5495 57.8853 14.1218 57.8853 14.7185V47.1185H38.5718V48.461H25.4278V47.1185H6.1123Z",
    fill: "#CEE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47363 16.827C9.47363 16.2747 9.92135 15.827 10.4736 15.827H53.5256C54.0779 15.827 54.5256 16.2747 54.5256 16.827V42.7565C54.5256 43.3088 54.0779 43.7565 53.5256 43.7565H10.4736C9.92135 43.7565 9.47363 43.3088 9.47363 42.7565V16.827Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5718 46.6185H38.0718V47.1185V47.961H25.9278V47.1185V46.6185H25.4278H3.15332H2.65332V47.1185V49.2845C2.65332 50.0139 2.94305 50.7133 3.45878 51.2291C3.9745 51.7448 4.67398 52.0345 5.40332 52.0345H58.5963C59.3257 52.0345 60.0251 51.7448 60.5409 51.2291C61.0566 50.7133 61.3463 50.0139 61.3463 49.2845V47.1185V46.6185H60.8463H38.5718Z",
    fill: "#CEE7FF",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.3496,
    y: 20.3,
    width: 24.15,
    height: 43.7,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.8496,
    y: 20.8,
    width: 23.15,
    height: 42.7,
    rx: 3.5,
    stroke: "#B9DDFF",
    strokeOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6504,
    y: 22.6,
    width: 19.55,
    height: 39.1,
    rx: 3,
    fill: "#5283EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5498,
    y: 26.05,
    width: 5.75,
    height: 1.15,
    rx: 0.575,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.36aa834c486b4e92ac2d8bb44b8fc0ce.svg";
export { ForwardRef as ReactComponent };